import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        validStates: Array,
    }

    connect() {
        this.observer = new MutationObserver(this.handleMutations.bind(this))
        this.observer.observe(this.element, { childList: true, subtree: true })

        this.validStates = [".UNSTARTED", ".UNFINISHED", ".INCORRECT", ".FETCHING"]
    }

    disconnect() {
        if (this.observer) this.observer.disconnect()
        if (this.interval) clearInterval(this.interval)
    }

    handleMutations() {
        const solutionInput = this.element.querySelector("input[name=frc-captcha-solution]")
        const submitInput = this.element.querySelector("button[type=submit]")

        if (solutionInput) {
            this.solutionInput = solutionInput
            this.submitInput = submitInput
            this.startChecking()
            this.observer.disconnect() // stop observing once found
        }
    }

    startChecking() {
        this.interval = setInterval(() => {
            const value = this.solutionInput.value
            const solutionInput = this.element.querySelector("input[name=frc-captcha-solution]")
            const submitInput = this.element.querySelector("button[type=submit]")
            this.solutionInput = solutionInput
            this.submitInput = submitInput
            if (!this.validStates.includes(value)) {
                this.submitInput.removeAttribute("disabled")
                clearInterval(this.interval)
            }
        }, 500)
    }
}
